import { Component } from '@angular/core';
import { DocViewerStore } from "@store/legacy/doc-viewer.store";
import { ReviewManager } from "@managers/review.manager";
import { takeUntil } from "rxjs";
import { BaseComponent } from "../../../base.component";
import { Store } from "@ngrx/store";
import { currentDocListContext } from "@store/doc-viewer/document-list/document-list.selectors";
import { DocumentConextListState } from '@store/doc-viewer/document-list/document-list.state';

@Component({
    selector: 'lex-browse-context-panel',
    templateUrl: './browse-context-panel.component.html',
    styleUrls: ['./browse-context-panel.component.scss'],
    standalone: false
})
export class BrowseContextPanelComponent extends BaseComponent {
	
	public docsContext: DocumentConextListState;
	public currentDocumentId: string = '';
	public pointerDocId: string = '';
	public panelState: 'expanded' | 'collapsed' = 'expanded';
	public panelExpandWidth: number = 310;
	public panelCollapseWidth: number = 55;
	public maxAnimationWidth: string;
	public isAnimationDisabled: boolean = true;

	constructor(
		private docViewerStore: DocViewerStore,
		private reviewManager: ReviewManager,
		private store: Store
	) {
		super();
		this.docViewerStore.currentDocument$.pipe(
			takeUntil(this.destroy$)
		).subscribe((currentDocument) => {
			this.currentDocumentId = currentDocument.docId;
		});

		this.store.select(currentDocListContext).pipe(
			takeUntil(this.destroy$)
		).subscribe((docListContext) => {
			this.docsContext = docListContext;
		});
	}

	public goToDocument(documentId: string) {
		this.reviewManager.continueWithoutSavingConfirmationDialog().subscribe((confirm) => {
			if (confirm)
				this.reviewManager.loadDocument(documentId);
		});
	}
}
